import { Modal } from "react-bootstrap";
import { CXButton } from "../../../components/CXForm";
import { ActionType } from "./ITable";

interface IColumnObject {
  name: string;
  value: string;
}

export interface IDeleteNewsModalProps {
  isShow: boolean;
  modelTitle?: string;
  modelDetailTitle?: string;
  dataList: IColumnObject[];
  actionsCallback?: (action: ActionType, data: any) => void;
}

export const DeleteNewsModal = ({
  isShow,
  modelTitle = "Delete news",
  modelDetailTitle = "Are you sure to delete the following news?",
  dataList,
  actionsCallback,
}: IDeleteNewsModalProps) => {
  const closeModal = () => {
    actionsCallback && actionsCallback(ActionType.CLOSE_MODAL, null);
  };

  const handleDelete = () => {
    actionsCallback && actionsCallback(ActionType.DELETE_CONFIRM, null);
  };

  return (
    <Modal
      className="newsModal"
      show={isShow}
      dialogClassName="modal-90w"
      onHide={closeModal}
      size="xl"
    >
      <Modal.Header className="modal-header" closeButton>
        <Modal.Title className="modal-title">{modelTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-section-title">{modelDetailTitle}</div>
        <div className="d-flex modal-list">
          {
            dataList.map((item, index) => {
              return (
                <div key={index} className="mb-3 me-3">
                  <div className="modal-col-name">{item.name}</div>
                  <div className="modal-col-value">{item.value}</div>
                </div>
              );
            })
          }
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <>
          <div className="cancel-button">
            <CXButton
              outline={true}
              text={"Cancel"}
              onClick={() => closeModal()}
              fontSize={"16px"}
              width={"100%"}
            />
          </div>
          <div className="save-button">
            <CXButton
              text={"Confirm"}
              onClick={() => handleDelete()}
              fontSize={"16px"}
              width={"100%"}
            />
          </div>
        </>
      </Modal.Footer>
    </Modal>
  );
};
